//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EventSaleForm from './form.vue';
import EventSaleBadge from './badge.vue';
import EventSaleMessage from './message.vue';
import EventSaleTimer from './timer.vue';
import ViewportMixin from '@/mixins/viewport.mixin';

export default {
  components: {
    EventSaleForm,
    EventSaleBadge,
    EventSaleMessage,
    EventSaleTimer,
  },
  mixins: [ViewportMixin],
  props: {
    variant: {
      type: String,
      default: 'a',
    },
  },
  data() {
    return {
      data: null,
      eventSlug: null,
      eventEnded: false,
    };
  },
  async fetch() {
    const eventSlug = this.$route.params.eventSlug;
    const saleSlug = this.$route.params.saleSlug;

    const lastIndex = saleSlug.lastIndexOf('-sale');
    const nomenclatureSlug = saleSlug.substring(0, lastIndex);

    this.data = await this.getSale(nomenclatureSlug, eventSlug);
    this.$emit('getSale', this.data);

    if (!this.data) {
      this.$nuxt.error({ statusCode: 404, message: 'Sale not found' });
      return;
    }

    this.eventSlug = eventSlug;
  },
  watch: {
    data: {
      handler(newVal) {
        this.$emit('getSale', newVal);
      },
      deep: true,
    },
  },
  methods: {
    async getSale(nomenclatureSlug, eventSlug) {
      try {
        const response = await this.$axios({
          method: 'post',
          url: `${this.$app.config.current.CMS_REST_API}/public/getSale/`,
          data: {
            limit: 10,
            offset: 0,
            nomenclatureSlug,
            eventSlug,
          },
        });

        const { data } = response?.data || {};

        if (data?.length > 1) {
          data.sort((a, b) => {
            if (a.topic_date_utc > b.topic_date_utc) return -1;
            if (a.topic_date_utc < b.topic_date_utc) return 1;
            return 0;
          });

          const currentUtcTime = this.$dayjs.utc();
          const currentTopic = data.find(
            (topic) => this.$dayjs.utc(topic.topic_date_utc) <= currentUtcTime,
          );

          const sale = currentTopic || data.pop();
          return sale;
        } else if (data?.[0]) return data[0];
      } catch (e) {
        console.error(e);
      }
    },
  },
};
